import { bindable, bindingMode } from "aurelia-framework";

let id = 0;

/**
 * A simple checkbox component which cares about setting focus correctly.
 *
 * Usage:
 *
 * <k-checkbox model.bind="mymodel" checked.bind="...">
 *     My Checkbox
 * </k-checkbox>
 */
export class KCheckboxCustomElement {
  hasFocus: boolean = false;
  inputId: string = `k-checkbox-${id++}`;

  @bindable({ defaultBindingMode: bindingMode.twoWay }) name: string;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) model: any;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) checked: boolean;
}
